import * as React from 'react';
import './App.css';

class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <div>
          <img src="/images/taut-medium.png" className="App-logo" alt="logo" />
          <div>Coming soon...</div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx